import React, { useContext } from 'react'

import { DeserializedSavedFilter } from 'api'
import RefreshActivity from 'components/RefreshActivity'
import { SortAndFilters } from 'components/SortAndFilter'
import { FilterGroup,FilterPage } from 'context/filtersContext'
import { SortContext } from 'context/sortContext'
import { PagedResponseData } from 'hooks/paginationAndApiUtils'
import { useAttributeFilters } from 'hooks/useAttributeFilters'
import { Insight } from 'modules/accountActivity/domain'
import { defaultFilterTypes } from 'utils/filters'

import styles from '../styles.module.css'

interface GroupedActivitiesControlsProps {
  insightsFeed: {
    insights: PagedResponseData<Insight>
    count: number | undefined
    refresh: () => void
  }
  filterPage: FilterPage
  accountId?: string
  calendarOpenDirection?: 'up' | 'down'
  showSearch?: boolean
  onFilterChange?: () => void
  activeFilterId?: number
  onOpenEditModal?: (filter?: DeserializedSavedFilter, filterGroups?: FilterGroup[]) => void
  onClear?: () => void
}

const GroupedActivitiesControls: React.FC<GroupedActivitiesControlsProps> = ({
  insightsFeed,
  filterPage,
  accountId,
  calendarOpenDirection,
  showSearch = true,
  activeFilterId,
  onFilterChange,
  onOpenEditModal,
  onClear
}) => {
  const attributeFilters = useAttributeFilters()
  const { activitiesSort, activitiesDescending } = useContext(SortContext)
  const { insights, count, refresh } = insightsFeed

  return (
    <div className={styles.savedViewsFilters}>
      {attributeFilters ? (
        <SortAndFilters
          onOpenEditModal={onOpenEditModal}
          onClear={onClear}
          onFilterChange={onFilterChange}
          selectedSort={activitiesSort}
          descending={activitiesDescending}
          singularName="activity group"
          pluralName="activity groups"
          dataLength={count}
          filterPage={filterPage}
          activeFilterId={activeFilterId}
          availableFilters={defaultFilterTypes}
          attributeFilters={attributeFilters}
          calendarOpenDirection={calendarOpenDirection}
          showSearch={showSearch}
          tooltip={
            <>
              Activities from contacts at the same account that occur in the same 30-minute session
              are grouped
            </>
          }
        />
      ) : (
        <div className={styles.filtersLoading} />
      )}
      {insights.hasLoadedInitialData && (
        <RefreshActivity
          prevCount={count}
          onClick={() => refresh()}
          legacyInsightsOnly={true}
          filterPage={filterPage}
          accountId={accountId}
        />
      )}
    </div>
  )
}

export default GroupedActivitiesControls
